import { api } from '../../api';

import { fetchProfile, postLogin, setDevice, setSignOut } from './fetchAuth';

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    postLogin: postLogin(build),
    fetchProfile: fetchProfile(build),
    setDevice: setDevice(build),
    setSignOut: setSignOut(build),
  }),
  overrideExisting: false,
});

export const {
  usePostLoginMutation,
  useLazyFetchProfileQuery,
  useSetDeviceMutation,
  useSetSignOutMutation,
} = userApi;
